import { SvgIcon } from '@material-ui/core';
import type { SvgIconProps } from '@material-ui/core';

/**
 * The Claude starburst, for the Marketplace sidebar item.
 *
 * `fill` is left to inherit — SvgIcon sets `fill: currentColor`, so the mark
 * takes the sidebar item's own colour in whichever theme is active, including
 * its hover and selected states. Hard-coding a light and a dark value would
 * pin two more colours to keep in step with the ramp, and would still be wrong
 * on the selected tile, which is not the same colour as the rail behind it.
 *
 * Twelve rays of uneven length, faceted rather than needle-pointed. Drawn a
 * little heavier than the source artwork because the rail renders it at 24px,
 * where finer rays drop out and it reads as a blob beside the solid Material
 * icons it sits next to.
 */
export const MarketplaceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 640 640">
    <path d="M372 305L176 5L154 15L272 355ZM378 336L367 9L343 7L266 324ZM366 364L529 82L511 68L278 296ZM357 286L68 111L52 129L287 374ZM333 385L634 280L630 256L311 275ZM327 274L9 288L7 312L317 386ZM317 386L613 368L615 344L327 274ZM294 281L68 460L80 480L350 379ZM287 374L553 529L567 511L357 286ZM276 298L140 565L160 579L368 362ZM266 324L280 631L304 633L378 336ZM276 362L482 585L502 571L368 298Z" />
  </SvgIcon>
);
